<template>
  <b-row>
    <b-col sm="12">
      <h3>
        <slot></slot>
      </h3>
    </b-col>
  </b-row>
</template>
<script>
export default{
  name: 'SubHeader'
}
</script>
